export default __webpack_public_path__ + "static/media/2210.d2ffbd71.png";